import React from 'react'
import './Loading.css'

function Loading() {
    return (
        <div className="load_wrapper">
            <div className="load_header">
                Loading 
                <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
            </div>
            <div className="load_icon">
                S
            </div>
            
        </div>
    )
}

export default Loading
